import dynamic from 'next/dynamic';

import { ButtonProps, ButtonTextColorMode } from 'src/components/blocks/ButtonBlock';
import { trackImpression, trackLinkClick } from 'src/tracking/components/button';
import { ContentBlockRenderer } from 'src/types/Block';
import { ContentstackSection } from 'src/types/Contentstack';
import { PlacementContext } from 'src/types/PlacementContext';
import { Transformer } from 'src/types/Transformer';

export interface ContentstackButton extends ContentstackSection {
  background_color: string;
  text_color_mode: string;
  text: string;
  href: string;
  tracking_title: string;
}

interface ButtonSerializedData {
  customBackgroundColor: string;
  textColorMode: ButtonTextColorMode;
  href: string;
  children: string;
  trackingTitle: string;
  trackingPosition?: number;
}

export const renderer: ContentBlockRenderer<ButtonSerializedData, ButtonProps> = {
  Component: dynamic<ButtonProps>(() =>
    import('src/components/blocks/ButtonBlock').then((mod) => mod.ButtonBlock),
  ),
  getProps: ({ ...serializedData }) => {
    const { trackingPosition, trackingTitle, ...restOfSerializedData } = serializedData;
    const dataForTracking: PlacementContext = {
      trackingPosition,
      trackingTitle,
    };

    return {
      ...restOfSerializedData,
      onVisible: () => trackImpression(dataForTracking),
      onClick: (e: React.MouseEvent<HTMLAnchorElement>) => trackLinkClick(e, dataForTracking),
    };
  },
};

export const transformer: Transformer<ContentstackButton, ButtonSerializedData, ButtonProps> = ({
  _metadata,
  background_color,
  text_color_mode,
  text,
  href,
  tracking_title,
}) => ({
  uid: _metadata.uid,
  renderer,
  serializedData: {
    customBackgroundColor: background_color,
    textColorMode: text_color_mode as ButtonTextColorMode,
    href,
    children: text,
    trackingTitle: tracking_title,
  },
});
